// src/lib/firebase.ts
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyCNfuqKeM_Vjn57H-kqNxUEgUxyipeCa1k",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "influencehub-d596e.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "influencehub-d596e",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "influencehub-d596e.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "561469577003",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:561469577003:web:cc81d070b7ba8e48b6176e",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-D6SE1WF8TZ",
};

// Avoid re-initializing on hot reloads
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);

// Note: Persistence is set per-login in the Login component based on "Remember Me" checkbox
// Do NOT set persistence here - it will be set dynamically during login

export const db = getFirestore(app);
